<template>
  <svg
    width="7"
    height="11"
    viewBox="0 0 7 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_14_6)">
      <path
        d="M1.35714 9.78571L5.64285 5.49999L1.35714 1.21428"
        stroke="#6C6D84"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_14_6">
        <rect
          width="7"
          height="11"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
